// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1Kt-K","description":"PatientConsentPreview_description__eiFtb"};